import { animation, Column, space } from '@zipdrug/ui';
import { StyleSheet } from 'aphrodite/no-important';
import aphroditePropType from 'aphrodite-prop-type';
import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import DeliveryForm from './DeliveryForm';
import DeliveryFormFeaturePlaceholder from './DeliveryFormFeaturePlaceholder';
import DeliveryFormSuccess from './DeliveryFormSuccess';

const CONTAINER_ANIMATION = {
  from: { transform: `translateX(${space.half})` },
  to: { transform: 'translateX(0)' },
};

const sx = StyleSheet.create({
  container: {
    ...animation.build({ name: [CONTAINER_ANIMATION, animation.fadeIn] }),
    overflowX: 'hidden',
    width: '30rem',
  },
});

const DeliveryFormConductor = ({
  currentPharmacy,
  styles,
  submitSucceeded,
  onClickCancel,
  submitting,
  ...props
}) => {
  let content = null;

  const handleClickCancel = useCallback(() => {
    if (!submitting && onClickCancel) {
      onClickCancel();
    }
  }, [onClickCancel, submitting]);

  if (!isNil(currentPharmacy) && !currentPharmacy.onfleet_id) {
    content = <DeliveryFormFeaturePlaceholder {...props} onClickCancel={handleClickCancel} />;
  } else if (submitSucceeded) {
    content = <DeliveryFormSuccess {...props} onClickCancel={handleClickCancel} />;
  } else {
    content = <DeliveryForm {...props} onClickCancel={handleClickCancel} />;
  }

  return <Column styles={[sx.container, styles]}>{content}</Column>;
};

DeliveryFormConductor.propTypes = {
  currentPharmacy: PropTypes.object,
  styles: aphroditePropType,
  submitSucceeded: PropTypes.bool,
  onClickCancel: PropTypes.func,
  submitting: PropTypes.bool,
};

export default DeliveryFormConductor;
